import { render, staticRenderFns } from "./MilkDisposal.vue?vue&type=template&id=14f81699&scoped=true&"
import script from "./MilkDisposal.vue?vue&type=script&lang=js&"
export * from "./MilkDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f81699",
  null
  
)

export default component.exports